export class ActiveStep {
  private static reloadActiveStepCallback: (() => void) | null = null;
  private static activeStepName: string | undefined = undefined;

  public static setActiveStepAfter(step: () => void, name?: string) {
    ActiveStep.reloadActiveStepCallback = step;
    ActiveStep.activeStepName = name;
  }

  public static reloadActiveStep() {
    ActiveStep.reloadActiveStepCallback?.();
  }

  public static isItActiveStep(name: string) {
    return ActiveStep.activeStepName === name;
  }
}
